export default "__VITE_ASSET__Cm26HGdD__"